function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M18 18h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c2.2 0 4-1.8 4-4s-1.8-4-4-4h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c3.3 0 6 2.7 6 6s-2.7 6-6 6zm-9 0H6c-3.3 0-6-2.7-6-6s2.7-6 6-6h3c.6 0 1 .4 1 1s-.4 1-1 1H6c-2.2 0-4 1.8-4 4s1.8 4 4 4h3c.6 0 1 .4 1 1s-.4 1-1 1z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16 13H8c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1z"
});

var SvgLink = function SvgLink(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE4LDE4aC0zYy0wLjYsMC0xLTAuNC0xLTFzMC40LTEsMS0xaDNjMi4yLDAsNC0xLjgsNC00YzAtMi4yLTEuOC00LTQtNGgtM2MtMC42LDAtMS0wLjQtMS0xczAuNC0xLDEtMWgzYzMuMywwLDYsMi43LDYsNgoJUzIxLjMsMTgsMTgsMTh6IE05LDE4SDZjLTMuMywwLTYtMi43LTYtNnMyLjctNiw2LTZoM2MwLjYsMCwxLDAuNCwxLDFTOS42LDgsOSw4SDZjLTIuMiwwLTQsMS44LTQsNGMwLDIuMiwxLjgsNCw0LDRoMwoJYzAuNiwwLDEsMC40LDEsMVM5LjYsMTgsOSwxOHoiLz4KPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTYsMTNIOGMtMC42LDAtMS0wLjQtMS0xczAuNC0xLDEtMWg4YzAuNiwwLDEsMC40LDEsMVMxNi42LDEzLDE2LDEzeiIvPgo8L3N2Zz4K";
export { SvgLink as ReactComponent };